import React from "react";
import { useCartao } from "../hooks/cartao";
const Bloco2: React.FC = () => {
  const { passo } = useCartao();
  return (
    <>
      {passo === 0 && (
        <section className="bg-theme2">
          <div className="container items-center px-5 py-16 lg:py-10 mx-auto lg:flex-row lg:px-18">
            <div className="mx-auto w-5/6">
              <div className="lg:px-28">
                <h1 className="text-xl lg:text-2xl font-semibold tracking-tight text-gray-500">
                  Por que desbloquear seu cartão?
                </h1>
                <p className="leading-tight tracking-tight text-lg lg:text-xl pt-4 text-gray-500">
                  A Dental Uni se preocupa com os dados de seus beneficiários, e
                  o processo de desbloqueio do cartão é mais uma forma de
                  cumprir o que impõe a Lei Geral de Proteção de Dados (LGPD),
                  para confirmar e atualizar alguns dados dos beneficiários.
                </p>
              </div>
              <div className="h-px bg-gray-500 my-12"></div>
              <div className="lg:px-28">
                <h1 className="text-xl lg:text-2xl font-semibold tracking-tight text-gray-500">
                  Quem deve desbloquear o cartão?
                </h1>
                <p className="leading-tight tracking-tight text-lg lg:text-xl pt-4 text-gray-500">
                  Novos beneficiários (dependentes ou titulares), 2ª via de
                  beneficiários antigos e quando houver migração de plano
                  odontológico.
                </p>
              </div>
              <div className="h-px bg-gray-500 my-12"></div>
              <div className="lg:px-28">
                <h1 className="text-xl lg:text-2xl font-semibold tracking-tight text-gray-500">
                  O que acontece se o cartão não for desbloqueado?
                </h1>
                <p className="leading-tight tracking-tight text-lg lg:text-xl pt-4 text-gray-500">
                  O cartão deve ser desbloqueado para autorizar o início do uso
                  do plano. Sem o desbloqueio não é possível receber
                  atendimento. Por isso, recomendamos realizar o desbloqueio
                  assim que receber a carteirinha, evitando esquecimentos.
                </p>
              </div>
              <div className="h-px bg-gray-500 my-12"></div>
              <div className="lg:px-28">
                <h1 className="text-xl lg:text-2xl font-semibold tracking-tight text-gray-500">
                  O titular pode desbloquear os cartões dos dependentes?
                </h1>
                <p className="leading-tight tracking-tight text-lg lg:text-xl pt-4 text-gray-500">
                  Não! Seguindo o que impõe a Lei Geral de Proteção de Dados
                  (LGPD), o desbloqueio deve ser realizado pelo próprio
                  dependente maior de idade. Já o desbloqueio de dependentes
                  menores de idade é realizado juntamente com o do titular do
                  plano.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Bloco2;
